import { GorgiasOrderStatusEnum } from '../../lib/ssp/types';

export const hiddenStatuses = [
  GorgiasOrderStatusEnum.STATUS_UNAVAILABLE,
  GorgiasOrderStatusEnum.SHIPMENT_STATUS_UNAVAILABLE,
];

// eslint-disable-next-line import/prefer-default-export
export const colorMapping: {
  [key: string]: string;
} = {
  [GorgiasOrderStatusEnum.UNFULFILLED]: 'grey',
  [GorgiasOrderStatusEnum.PROCESSING_FULFILLMENT]: 'grey',
  [GorgiasOrderStatusEnum.PENDING_DELIVERY]: 'primary',
  [GorgiasOrderStatusEnum.ATTEMPTED_DELIVERY]: 'secondaryRed',
  [GorgiasOrderStatusEnum.READY_FOR_PICKUP]: 'secondaryGreen',
  [GorgiasOrderStatusEnum.IN_TRANSIT]: 'secondaryGreen',
  [GorgiasOrderStatusEnum.OUT_FOR_DELIVERY]: 'secondaryGreen',
  [GorgiasOrderStatusEnum.DELIVERED]: 'dark',
  [GorgiasOrderStatusEnum.FAILED_DELIVERY]: 'secondaryRed',
  [GorgiasOrderStatusEnum.CANCELLED]: 'secondaryRed',
  [GorgiasOrderStatusEnum.FAILED_FULFILLMENT]: 'secondaryRed',
  [GorgiasOrderStatusEnum.PARTIALLY_REFUNDED]: 'secondaryNavy',
  [GorgiasOrderStatusEnum.REFUNDED]: 'secondaryNavy',
  [GorgiasOrderStatusEnum.STATUS_UNAVAILABLE]: 'grey',
  [GorgiasOrderStatusEnum.SHIPMENT_STATUS_UNAVAILABLE]: 'grey',
};
